import createModule from "../createModule"
import view from "./view"
import { get } from "lodash"
import { Creators as DialogCreators } from "modules/dialog/model"
import { MODELS_AVAILABILITY_QUERY, buildModelsCoverageRequest } from "helpers/models"
import { getSortedModelsByCoverage, getModelsDates, getResourceType } from "./selectors"

export default createModule({
  view,
  externalProps: (state, props) => ({
    resourceType: getResourceType(state, props),
    resourceId: get(props, "resourceId"),
    account: state.global.selected.account,
    modelsDates: getModelsDates(state, props),
  }),
  required: ["account"],
  data: [{
    resource: "modelsAvailability",
    url: () => ({
      id: "models",
      query: MODELS_AVAILABILITY_QUERY,
    }),
  }, {
    resource: "modelsCoverage",
    url: buildModelsCoverageRequest,
  }],
  mapStateToProps: (state, props) => ({
    sortedModelsByCoverage: getSortedModelsByCoverage(state, props),
  }),
  actions: {
    openDialog: DialogCreators.open,
  },
})
